export const TextLinkStyle:React.CSSProperties = {
  display: "flex",
  alignItems: "center",
  alignSelf: "stretch",
  gap: "8px",
  padding: "0px 8px",
  borderRadius: "16px",
  background: "rgba(51, 51, 51, 0.00)"
}

export const TextLinkGroupStyle:React.CSSProperties = {
  alignItems: "center",
  alignSelf: "stretch",
  gap: "8px",
  padding: "0px 8px",          
  background: "#fff",  
  borderTop:"0px",
  borderLeft:"1px solid rgba(192,192,192,0.5)",
  borderRight:"1px solid rgba(192,192,192,0.5)",  
  borderRadius:"10px",  
  zIndex:"1",
  boxShadow: "2px 2px 5px hsl(0deg 0% 0% / 0.38)",
}

export const TextLinkChildStyle:React.CSSProperties = {
  display: "block",
  position: "relative",
  zIndex: "1",
  alignItems: "center",
  alignSelf: "stretch",
  gap: "8px",
  padding: "0px 8px",
  borderRadius: "16px",
  background: "rgba(51, 51, 51, 0.00)"
}

export const TextLinkAStyle:React.CSSProperties = {
  alignItems: "center",
  gap: "4px",
  padding: "2px 8px",
  color: "#FFFFFF",
  fontFeatureSettings: "'ss04' on, 'ss05' on, 'ss03' on, 'ss02' on, 'ss01' on",
  fontFamily: "FS Elliot Pro Regular",
  fontSize: "18px",
  fontStyle: "normal",
  fontWeight: "700",
  lineHeight: "28px",
  textDecoration: "none",
}

export const TextLinkGroupAStyle:React.CSSProperties = {
  alignItems: "center",
  gap: "4px",
  padding: "2px 8px",
  color: "#333333",
  fontFeatureSettings: "'ss04' on, 'ss05' on, 'ss03' on, 'ss02' on, 'ss01' on",
  fontFamily: "FS Elliot Pro Regular",
  fontSize: "18px",
  fontStyle: "normal",
  fontWeight: "700",
  lineHeight: "28px",
  textDecoration: "none",
}